import { styled } from "goober";
import { hiddenScopeLabel } from "../lib/roleChip";
import { Icon } from "./Icon";
import { Text } from "./Text";

const Row = styled("div")`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
`;

const IconContainer = styled("div")`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--alpha4);
  color: var(--text-tertiary);
`;

export function RedactedScopeRow({
  count,
  scopeKind,
}: {
  count: number;
  scopeKind: string;
}) {
  if (count === 0) return null;
  return (
    <Row>
      <IconContainer>
        <Icon name="eye-closed" size={16} />
      </IconContainer>
      <Text variant="text-regular-md" color="var(--text-tertiary)">
        {hiddenScopeLabel(count, scopeKind)}
      </Text>
    </Row>
  );
}
